import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="markdown-preview"
export default class extends Controller {
  static targets = ["editor", "preview", "editorButton", "previewButton"];
  static values = {
    previewUrl: String,
    csrfToken: String
  };

  connect() {
    // Initially show editor, hide preview
    this.showEditor();
  }

  showPreview(event) {
    event.preventDefault();

    const markdownText = this.editorTarget.value;

    // Show preview button, hide editor button
    this.previewButtonTarget.classList.add("d-none");
    this.editorButtonTarget.classList.remove("d-none");

    // Hide editor, show preview
    this.editorTarget.classList.add("d-none");
    this.previewTarget.classList.remove("d-none");

    // Fetch rendered markdown
    this.fetchPreview(markdownText);
  }

  showEditor(event) {
    if (event) event.preventDefault();

    // Show editor button, hide preview button
    this.editorButtonTarget.classList.add("d-none");
    this.previewButtonTarget.classList.remove("d-none");

    // Show editor, hide preview
    this.editorTarget.classList.remove("d-none");
    this.previewTarget.classList.add("d-none");
  }

  async fetchPreview(markdownText) {
    try {
      const response = await fetch(this.previewUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfTokenValue
        },
        body: JSON.stringify({ markdown: markdownText })
      });

      if (response.ok) {
        const html = await response.text();
        this.previewTarget.innerHTML = html;
      } else {
        this.previewTarget.innerHTML =
          '<div class="alert alert-danger">Error rendering preview</div>';
      }
    } catch (error) {
      console.error("Error fetching preview:", error);
      this.previewTarget.innerHTML =
        '<div class="alert alert-danger">Error rendering preview</div>';
    }
  }
}
